export const RARITY_ICONS: Record<string, string> = {
  'Common': '/imgs/common.svg',
  'Uncommon': '/imgs/uncommon.svg',
  'Rare': '/imgs/rare.svg',
  'Super Rare': '/imgs/super_rare.svg',
  'Legendary': '/imgs/legendary.svg',
  'Epic': '/imgs/epic.png',
  'Enchanted': '/imgs/enchanted.png',
  'Iconic': '/imgs/iconic.png',
  'Special': '/imgs/promo.png',
  'Promo': '/imgs/promo.png'
};

export const COLOR_ICONS: Record<string, string> = {
  'Amber': '/imgs/amber.svg',
  'Amethyst': '/imgs/amethyst.svg',
  'Emerald': '/imgs/emerald.svg',
  'Ruby': '/imgs/ruby.svg',
  'Sapphire': '/imgs/sapphire.svg',
  'Steel': '/imgs/steel.svg'
};
